import { rem } from 'polished';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;

  p {
    margin: 0 0 ${rem(12)} 0;
    font-size: ${rem(14)};
    line-height: 140%;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .alert {
    body & > div span {
      font-weight: 600;
      padding-right: ${rem(8)};
    }

    .cta {
      margin-left: auto;

      span {
        font-size: ${rem(12)};
        font-weight: 400;
      }
    }
  }
`;
